import React from 'react';

export const IsRoot = [
  {
    param: 'is_root',
    type: 'boolean',
    required: false,
    description: (
      <p>
        Whether this entity is going to be a root entity of the platform. Root entities have special requirements and
        validation rules.
      </p>
    ),
  },
];
